<nz-page-header nzTitle="Dynamic Entity" nzSubtitle="Select the entity type you want to view/edit"></nz-page-header>

<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<tbody>
		<tr *ngFor="let item of data">
			<td>
				<a [routerLink]="['/dynamic',item.id]" class="btn btn-sm btn-secondary">Open</a>
				{{item.label}}
			</td>
			<td>{{item.description}}</td>
		</tr>
	</tbody>
</nz-table>
